import React, { FC } from 'react';
import './searchVisitors.scss';
import type { ClickListData } from 'components/Form/ListSearch/types';
import FormSection from '../FormSection';
import ListSearch from '../ListSearch';

interface SearchVisitorsProps {
    savedVisitors: ClickListData[];
    onSelect: (value: string | number) => void;
    onClickEnterManually: () => void;
    selectedVisitors: number[];
    title?: string;
    showResults?: boolean;
}

const SearchVisitors: FC<SearchVisitorsProps> = ({ savedVisitors, onSelect, onClickEnterManually, selectedVisitors, title, showResults }) => (
    <div className="search-add-visitor-form-container">
        <FormSection title={title || 'Search Saved Visitors'}>
            <div className="list-search-wrapper">
                <ListSearch
                    listData={savedVisitors}
                    onSelect={onSelect}
                    selectedValues={selectedVisitors}
                    showSelectedValues
                    showResults={showResults !== false} />
            </div>
            <div className="button-wrapper">
                <button onClick={onClickEnterManually} type="button">Enter Visitor Details Manually</button>
            </div>
        </FormSection>
    </div>

);

SearchVisitors.defaultProps = {
    title: 'Search Saved Visitors',
    showResults: true,
};

export default SearchVisitors;
